import React, { useState } from 'react';
import MarkdownContent from '../shared/MarkdownContent';

const DEFAULT_MARKDOWN = `# KaTeX Preview

Inline math: $E = mc^2$

Block math:
$$
\\int_{-\\infty}^{\\infty} e^{-x^2} dx = \\sqrt{\\pi}
$$

Tables and GFM:

| a | b |
|---|---|
| 1 | 2 |
| 3 | 4 |

YouTube embed:

https://www.youtube.com/watch?v=dQw4w9WgXcQ
`;

const MarkdownPreviewPage: React.FC = () => {
  const [markdown, setMarkdown] = useState(DEFAULT_MARKDOWN);

  return (
    <div className="markdown-preview-page">
      <header className="markdown-preview-header">
        <h2>Markdown + KaTeX Preview</h2>
        <p>Uses the same renderer as chat messages.</p>
      </header>
      <div className="markdown-preview-body">
        <div className="markdown-input-pane">
          <label htmlFor="markdown-input">Markdown</label>
          <textarea
            id="markdown-input"
            value={markdown}
            onChange={(event) => setMarkdown(event.target.value)}
            spellCheck={false}
          />
        </div>
        <div className="markdown-preview-pane">
          <div className="preview-title">Preview</div>
          <div className="preview-content">
            <MarkdownContent content={markdown} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarkdownPreviewPage;
